module.exports = __webpack_public_path__ + "9a502a7ae7d88e6b9609b80c034d3829.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plaisirs-gastronomiques2/04.jpg
// module id = otR+
// module chunks = 0